import { render, staticRenderFns } from "./PledgeModal.vue?vue&type=template&id=12fd4502&"
import script from "./PledgeModal.vue?vue&type=script&lang=js&"
export * from "./PledgeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports